import { inject, injectable } from 'inversify';
import type { Tools, ToolStateStore } from '../ToolStateStore';
import { TYPES as IND_TYPES } from '../iocTypes';
import { SetIndicationToolCommand } from './SetIndicationTool.command';

@injectable()
export class IndicationsCommandsFactory {
  private readonly _toolsStateStore: ToolStateStore;

  public constructor(@inject(IND_TYPES.ToolStateStore) toolsStateStore: ToolStateStore) {
    this._toolsStateStore = toolsStateStore;
  }

  public createSetIndicationToolCommand(targetTool: Tools): SetIndicationToolCommand {
    return new SetIndicationToolCommand(this._toolsStateStore, targetTool);
  }
}
